import { ImageEditor } from "../imageeditor";

export class ActionBase {
  
  /**
   * @type {String}
   */
  name = "";

  /**
   * @type {ImageEditor}
   */
  imageEditor = null;

  /**
   * Constructeur
   * @param {String} name 
   * @param {ImageEditor} imageEditor 
   * @param {Object} opts 
   */
  constructor(imageEditor, name) {
    this.name = name;
    this.imageEditor = imageEditor;
  }

  /**
   * Perform the action.
   */
  performAction() {

  }

}